<template>
  <local-map :organisation-boundaries="organisationBoundaries"
             :filtered-boundaries="filteredBoundaries" />
</template>

<script>
import LocalMap from './local-map'
import { sharedMapPropsMixin } from './shared-map-props'
import { filterManagerMixin } from './filter-manager'

export default {
  components: {LocalMap},
  mixins: [filterManagerMixin, sharedMapPropsMixin],

  props: {
    propFilters: {
      type: Array,
      default: () => []
    },
    initialSearchedLocation: {
      type: Object,
      default: null
    }
  },

  created() {
    this.$store.commit('setUrlFilterKeys', this.urlFilterKeys)
    this.$store.commit('setSearchStrategy', this.searchStrategy)
    this.$store.commit('setSearchedLocation', this.initialSearchedLocation)
    this.$store.commit('setOptionsFromUrlAndFilters', this.propFiltersNotForUrl)
    this.$store.dispatch('getPoints')
  }
}
</script>
